import React from "react";
import ButtonTable from "../../common/table/buttonTable";
import DateFormat from "../../common/dateFormat/DateFormat";
import { ModalAlert } from "../../common/dialog/modalAlert";

export function ModalHistoricoDemandas(props) {
    return (
        <ModalAlert
            titulo="Histórico dos Contratos de Demanda"
            handleClose={() => {
                props.setItemSelecionado(null);
                props.setExibirModalHistorico(false);
            }}
        >
            <div style={{ maxHeight: 400, overflowY: "auto" }}>
                <table style={{ borderCollapse: "collapse", width: "100%" }}>
                    <thead>
                        <tr
                            style={{
                                position: "sticky",
                                zIndex: 1,
                                backgroundColor: "#586269",
                                color: "#FFF",
                                height: 40,
                                top: 0,
                            }}
                        >
                            <th style={{ paddingInline: 50 }}>Descrição</th>
                            <th style={{ textAlign: "center" }}>Nº da Tarefa</th>
                            <th style={{ textAlign: "center" }}>Status da Tarefa</th>
                            <th style={{ textAlign: "center" }}>Data/Hora</th>
                            <th style={{ textAlign: "center" }}>Usuário</th>
                            <th style={{ textAlign: "center" }}>Contrato CUSD</th>
                        </tr>
                    </thead>
                    <tbody>
                        {props.itemSelecionado.historico.map((h) => {
                            const coresStatus = {
                                Iniciada: "#009dff",
                                Excluída: "#ff174a",
                                Finalizada: "#00c864",
                                "Em andamento": "#f3ac49",
                            };

                            return (
                                <tr key={h.id} style={{ borderBlock: "1px solid #ccc", paddingTop: 30 }}>
                                    <td style={{ paddingInline: 50 }}>{h.descricao}</td>
                                    <td style={{ textAlign: "center" }}>{h.sequencia_ano || " - "}</td>
                                    <td style={{ textAlign: "center" }}>
                                        {h.status ? (
                                            <div style={{ color: "#FFF", minWidth: 110, borderRadius: "0.2rem", padding: 4, backgroundColor: coresStatus[h.status] }}>
                                                {h.status}{" "}
                                            </div>
                                        ) : (
                                            " - "
                                        )}
                                    </td>
                                    <td style={{ textAlign: "center" }}>{DateFormat.formatarDataHoraSqlParaTela(h.datahora_inclusao)}</td>
                                    <td style={{ textAlign: "center" }}>{h.nome_usuario}</td>
                                    <td style={{ verticalAlign: "top" }}>
                                        <div
                                            style={{
                                                position: "relative",
                                                display: "flex",
                                                flexDirection: "column",
                                                justifyContent: h.arquivo_cusd ? "start" : "center",
                                                alignItems: "center",
                                                minHeight: 40,
                                            }}
                                        >
                                            {h.arquivo_cusd ? (
                                                <ButtonTable
                                                    style={{ margin: 0 }}
                                                    title="Visualizar PDF"
                                                    type={"primary"}
                                                    icon={"fas fa-file-pdf"}
                                                    disabled={!h.arquivo_cusd}
                                                    visible={true}
                                                    event={() => {
                                                        props.buscarPdf(h.id);
                                                        props.setArquivoPDF();
                                                    }}
                                                />
                                            ) : (
                                                <div>-</div>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </ModalAlert>
    );
}
